import BookCardContent from './BookCardContent';

export default BookCardContent;
